import { useCallback, useEffect, useMemo, useState } from 'react';
import { DropDownTreeContext } from '@nbirl/nbi-common-ui-libs';

import { useFolderTree } from '../context';
import { Folder } from '../models';
import { SubFolderTree } from './sub-folder-tree.component';

type FoldersTreeProps = {
  selectedFolder?: Folder;
  selectedFolderPath: Folder[];
  onSelect: (id: string) => void;
};

export const FoldersTree = ({
  selectedFolder,
  selectedFolderPath,
  onSelect,
}: FoldersTreeProps) => {
  const { data } = useFolderTree();
  const foldersTree = data ?? [];

  const completeFoldersPath = useMemo(
    () => [...selectedFolderPath, ...(selectedFolder ? [selectedFolder] : [])],
    [selectedFolder, selectedFolderPath]
  );

  const [expandedFolders, setExpandedFolders] = useState<string[]>(
    completeFoldersPath.map(({ id }) => id)
  );

  const handleToggle = useCallback((id: string) => {
    setExpandedFolders((prevValue) => {
      const i = prevValue.indexOf(id);
      return i === -1 ? [...prevValue, id] : [...prevValue.slice(0, i)];
    });
  }, []);

  useEffect(
    () => setExpandedFolders(completeFoldersPath.map(({ id }) => id)),
    [completeFoldersPath]
  );

  return (
    <DropDownTreeContext.Provider
      value={{
        expandedFolders,
        selectedFolder: selectedFolder?.id,
        onToggle: handleToggle,
        onSelect,
      }}
    >
      <SubFolderTree folders={foldersTree} />
    </DropDownTreeContext.Provider>
  );
};
